// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offerManagementLoadingSection {
    background-color: white;
    margin-top: 24px;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}


.whiteBg {
    background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/offerManagementT/offerManagement.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,uBAAuB;AAC3B","sourcesContent":[".offerManagementLoadingSection {\n    background-color: white;\n    margin-top: 24px;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n.whiteBg {\n    background-color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
